import React, { useState } from "react";
import ReactBnbGallery from "react-bnb-gallery";
import classNames from "classnames";

import "react-bnb-gallery/dist/style.css";
import styles from "./photo_gallery.module.css";

const DEFAULT_WIDTH_PHOTO = 275;
const ONE_OR_TWO_WIDTH_PHOTO = 1140;
const THREE_OR_FOUR_WIDTH_PHOTO = 855;
const FIVE_OR_MORE_WIDTH_PHOTO = 570;
const PRIMARY_PHOTO_HEIGHT = 454;
const SECONDARY_PHOTO_HEIGHT = 222;

export default function PhotoGallery({ photos }) {
  const [activePhotoIndex, setActivePhotoIndex] = useState(null);

  const closeGallery = () => setActivePhotoIndex(null);

  const parsePhotos = photos.map((photo) => {
    return {
      photo: `${photo.url}-/resize/1920x/.jpg 1x`,
      thumbnail: `${photo.url}-/resize/58x/20.jpg 1x`,
    };
  });

  const previewList = photos.slice(0, 5);

  const isOneOrTwoPhotos = previewList.length === 1 || previewList.length === 2;
  const isThreeOrFourPhotos = previewList.length === 3 || previewList.length === 4;
  const isFiveOrMorePhotos = previewList.length >= 5;

  const getPhotoWidth = (index) => {
    let width = DEFAULT_WIDTH_PHOTO;

    if (isOneOrTwoPhotos) {
      width = ONE_OR_TWO_WIDTH_PHOTO;
    }
    if (isThreeOrFourPhotos && index === 0) {
      width = THREE_OR_FOUR_WIDTH_PHOTO;
    }
    if (isFiveOrMorePhotos && index === 0) {
      width = FIVE_OR_MORE_WIDTH_PHOTO;
    }
    return width;
  };

  const getPhotoHeight = (index) => {
    let height = PRIMARY_PHOTO_HEIGHT;

    if (index !== 0) {
      height = SECONDARY_PHOTO_HEIGHT;
    }

    return height;
  };

  const listClassName = classNames(styles.list, {
    [`${styles.list__oneOrTwo}`]: isOneOrTwoPhotos,
    [`${styles.list__threeOrFour}`]: isThreeOrFourPhotos,
    [`${styles.list__fiveOrMore}`]: isFiveOrMorePhotos,
  });

  return (
    <div className={styles.wrapper}>
      <div className={listClassName}>
        {previewList.map((photo, index) => {
          const itemClassName = classNames(styles.item, styles[`item--${index + 1}`]);
          const width = getPhotoWidth(index);
          const height = getPhotoHeight(index);
          const onOpenGallery = () => setActivePhotoIndex(index);
          const set = `
          ${photo.url}-/scale_crop/${width}x${height}/smart/.jpg,
          ${photo.url}-/scale_crop/${width * 2}x${height * 2}/smart/.jpg 2x`;

          return (
            <div className={itemClassName} key={photo.url} onClick={onOpenGallery}>
              <img
                className="d-block w-100"
                srcSet={set}
                src={`${photo.url}-/scale_crop/${width}x${height}/smart/.jpg`}
                alt={photo.description}
              />
            </div>
          );
        })}
      </div>
      <ReactBnbGallery
        activePhotoIndex={activePhotoIndex}
        show={activePhotoIndex !== null}
        photos={parsePhotos}
        onClose={closeGallery}
      />
    </div>
  );
}
